import { Box } from "@mui/material";
import { useStore } from "@tanstack/react-form";

import { withForm } from "components/Forms/AppForm";

import { ppFilterDefaultValues } from "../../context/ppFilterDefaultValues";

import PpHeaderText from "./PpHeaderText";

const titles = {
  approved: "APPROVED PROTECTION PROFILES",
  archived: "ARCHIVED PROTECTION PROFILES",
} as const;

const PpHeader = withForm({
  defaultValues: ppFilterDefaultValues,
  render: function Render({ form }) {
    const archived = useStore(form.store, (state) => state.values.archived);
    const isApproved = !archived;
    const title = isApproved ? titles.approved : titles.archived;

    return (
      <Box sx={{ marginX: 5, marginY: 2 }}>
        <h4
          className="text-black fw-bold mb-3"
          data-testid="profilesHeaderText"
        >
          PROTECTION PROFILES -{" "}
          <span className="text-bright-navy fw-bold">{title}</span>
        </h4>

        <PpHeaderText isApproved={isApproved} />
      </Box>
    );
  },
});

export default PpHeader;
